module.exports = __webpack_public_path__ + "img/515.7e72d32e.jpg";